<template>
  <Slide>
    <slot />
  </Slide>
</template>

<script setup lang="ts">
import { Slide } from 'vue3-carousel';
</script>